import React from 'react';
import './FoundersNote.css';

const FoundersNote = () => {
  return (
    <section className="founders-note-section">
      <div className="founders-note-content">
        <h3>- FOUNDER'S NOTE</h3><br />
        <p> We started Cognitva with a bold question:</p>
        <p className='quote'>'What if tomorrow's intelligence could be built once and reused everywhere?'</p>

        <p>
          With decades of leadership across AI, enterprise transformation, and compliance-heavy regulated sectors, we saw the limits of siloed, reactive tools. What was missing wasn't another chatbot or dashboard - it was <strong>an intelligent platform</strong>; AI that could adapt to healthcare, manufacturing , legal,  or finance, with context, trust, and speed.
        </p>

        <p style={{ marginTop: '20px' }}>
          So we built Cognitva CIP™ - a <strong>cross-industry intelligence platform</strong> designed to power decision-making at scale, while being modular, secure, and explainable.
        </p>
        <p style={{ marginTop: '20px' }}>Today, Cognitva isn't just a product.  It’s a new category -  AI Productization Platform for Regulated Enterprises.</p>


        <div className="signature">
          <p><strong>- Divya Singh,</strong> CEO</p>
          <p><strong>- Ram B. Adhikari,</strong> CTO</p>
        </div>
      </div>
    </section>
  );
};

export default FoundersNote; 